import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
  viewChild,
} from '@angular/core';
import { UiAuthLoginSubmitEvent } from '../auth-login/auth-login.component';
import {
  UiPortalClientesLoginComponent,
  UiPortalClientesLoginMode,
  UiPortalRecoverStep,
} from '../portal-clientes-login/portal-clientes-login.component';
import {
  UiRecaptchaSize,
  UiRecaptchaTheme,
} from '../../atoms/recaptcha/recaptcha.component';

export type UiPortalProveedoresLoginMode = UiPortalClientesLoginMode;
export type { UiPortalRecoverStep };

@Component({
  selector: 'ui-portal-proveedores-login',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [UiPortalClientesLoginComponent],
  template: `
    <ui-portal-clientes-login
      [logoSrc]="logoSrc()"
      [logoAlt]="logoAlt()"
      [title]="title()"
      [bannerSrc]="bannerSrc()"
      [bannerAlt]="bannerAlt()"
      [recaptchaSiteKey]="recaptchaSiteKey()"
      [recaptchaTheme]="recaptchaTheme()"
      [recaptchaSize]="recaptchaSize()"
      [recaptchaLanguage]="recaptchaLanguage()"
      [errorMessage]="errorMessage()"
      [mode]="mode()"
      [recoverStep]="recoverStep()"
      [showSupplierRegister]="true"
      (submitted)="submitted.emit($event)"
      (passwordPersonalized)="passwordPersonalized.emit()"
      (forgotPassword)="forgotPassword.emit()"
      (supplierRegister)="supplierRegister.emit()"
      (backToLogin)="backToLogin.emit()"
      (recoverSendCode)="recoverSendCode.emit($event)"
      (recoverValidateCode)="recoverValidateCode.emit($event)"
      (recoverSavePassword)="recoverSavePassword.emit()"
    />
  `,
})
export class UiPortalProveedoresLoginComponent {
  readonly logoSrc = input('/images/logo_azul.png');
  readonly logoAlt = input('Diseño y Gestión');
  readonly title = input('Portal de proveedores');
  readonly bannerSrc = input('/images/proveedores.png');
  readonly bannerAlt = input('Portal de proveedores');
  readonly recaptchaSiteKey = input.required<string>();
  readonly recaptchaTheme = input<UiRecaptchaTheme>('light');
  readonly recaptchaSize = input<UiRecaptchaSize>('normal');
  readonly recaptchaLanguage = input('es');
  readonly errorMessage = input('');
  readonly mode = input<UiPortalClientesLoginMode>('login');
  readonly recoverStep = input<UiPortalRecoverStep>(1);

  readonly submitted = output<UiAuthLoginSubmitEvent>();
  readonly passwordPersonalized = output<void>();
  readonly forgotPassword = output<void>();
  readonly supplierRegister = output<void>();
  readonly backToLogin = output<void>();
  readonly recoverSendCode = output<string>();
  readonly recoverValidateCode = output<string>();
  readonly recoverSavePassword = output<void>();

  private readonly inner = viewChild(UiPortalClientesLoginComponent);

  resetCaptcha(): void {
    this.inner()?.resetCaptcha();
  }
}
